import React from "react";

export const Contents = () => {
  return <div>Contents</div>;
};
